module.exports = __webpack_public_path__ + "img/cbrand1.bc27b843.png";